<template>
  <div class="jlxk-view-container">
    <Nav
      ref="commonNav"
      :nav-data="navData"
      :expand-id="expandId"
      :empty-text="emptyText"
      :first-level-view="true"
      @handleNodeClick="handleChangeNav"
    />
    <div class="list-container">
      <el-tabs
        v-model="currentList"
        v-show="expandFlag"
        @tab-click="handleChangeTab"
      >
        <el-tab-pane
          v-for="item in contentList"
          :key="item.name"
          :label="item.label"
          :name="item.name"
        />
      </el-tabs>
      <!-- 保证检索条件不重叠 -->
      <keep-alive>
        <List
          v-if="isNoPassList"
          ref="notPass"
          :class="{ 'jlxk-data-content-expand': expandFlag }"
          :total="total"
          :empty="empty"
          :btn-arr="btnArr"
          :list-data="listData"
          :is-show-status="true"
          :upload-u-r-l="uploadURL"
          :total-data="totalData"
          @updateList="getSpcialQuery"
          @changeSelected="changeSelected"
          @updateExpand="updateExpand"
          @handleCommand="handleCommand"
        />
      </keep-alive>
      <keep-alive>
        <List
          v-if="!isNoPassList"
          ref="passed"
          :class="{ 'jlxk-data-content-expand': expandFlag }"
          :total="total"
          :empty="empty"
          :is-show-status="false"
          :list-data="listData"
          :upload-u-r-l="uploadURL"
          @updateList="getSpcialQuery"
          @changeSelected="changeSelected"
          @updateExpand="updateExpand"
        />
      </keep-alive>
    </div>
    <el-tabs
      v-model="currentTab"
      :class="[
        'tag-tab-conditon',
        { 'tag-no-operate-conditon': !isNoPassList }
      ]"
    >
      <el-tab-pane
        v-for="item in tabList"
        :key="item.name"
        :label="item.label"
        :name="item.name"
      >
        <keep-alive>
          <components
            v-if="currentTab === item.name"
            :is="item.name"
            :ref="item.name"
            :current-item="currentItem"
            :top-data-code="topDataCode"
            :is-show-operate="isNoPassList"
            :btn-arr="detailArr"
            :is-can-add="isNoPassList"
            :is-show-review-oper="false"
            @handleCommand="handleCommand"
          />
        </keep-alive>
      </el-tab-pane>
    </el-tabs>
    <sureDialog
      ref="sureDialog"
      class="sureDialog"
      :is-show-footer="true"
      width="450px"
      :is-tran-cancel="true"
      @dialogSure="getSpcialDelete"
    >
      <div class="delete-icon-box">
        <i class="icon icon-warning" />
      </div>
      <div class="delete-text">
        {{ tips }}
      </div>
    </sureDialog>
  </div>
</template>

<script>
import { toTopAnimation } from '@common/util.js'
import Nav from '@views/jlxk/editor/components/nav'
import List from './components/list'
import detail from '@views/jlxk/dataView/components/detail'
import tag from '@views/jlxk/dataView/components/tag'
import reviewManage from '@views/jlxk/review/components/reviewManage'
import jlxkAPIS from '@apis/jlxk'
import APIS from '@apis/settings'
import sureDialog from '@components/dialog/cyDialogCommon'
export default {
  name: 'Editor',
  components: {
    Nav,
    detail,
    tag,
    List,
    reviewManage,
    sureDialog
  },
  props: {},
  data() {
    return {
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      emptyText: '',
      navData: [],
      expandId: [],
      topCurrentKey: '',
      secCurrentKey: '',
      currentTab: 'detail',
      tabList: [
        {
          name: 'detail',
          label: '详情'
        },
        {
          name: 'tag',
          label: '标签'
        },
        {
          name: 'reviewManage',
          label: '审核管理'
        }
      ],
      currentList: 'notPass',
      contentList: [
        {
          name: 'notPass',
          label: '未通过列表'
        },
        {
          name: 'passed',
          label: '已通过列表'
        }
      ],
      currentId: '',
      total: 0,
      listData: [],
      totalData: [],
      empty: '',
      active: 0,
      expandFlag: true,
      btnArr: [
        {
          id: 'delete',
          label: '批量删除'
        },
        {
          id: 'backout',
          label: '批量撤稿'
        }
      ],
      detailArr: [
        {
          id: 'alter',
          label: '修改',
          icon: 'jlxk-data-view-alter'
        },
        {
          id: 'delete',
          label: '删除',
          icon: 'jlxk-review-delete'
        },
        {
          id: 'backout',
          label: '撤稿',
          icon: 'jlxk-review-backout'
        }
      ],
      handleFlag: '',
      isDetail: false,
      categoryId: 'imageText', // 类型
      categoryObj: {
        0: 'imageText',
        1: 'imageText',
        2: 'atlas',
        3: 'booksFile',
        4: 'filmWoks',
        5: 'videoEditor',
        6: 'audioEditor'
      }
    }
  },
  computed: {
    currentItem() {
      return this.listData[this.active]
    },
    topDataCode() {
      if (!this.currentItem) return ''
      let id = this.currentItem.topDataCategoryId
      let obj = this.navData.filter(item => String(item.id) === String(id))[0]
      return (obj && obj.code) || ''
    },
    uploadURL() {
      return {
        path: '/jlxk/editor',
        query: {
          modelId: this.currentIndex,
          topId: this.topCurrentKey,
          secId: this.secCurrentKey,
          categoryId: this.categoryId
        }
      }
    },
    currentIndex() {
      return this.$store.state.currentIndex
    },
    dataArr() {
      return this.listData.map(item => item.id)
    },
    isNoPassList() {
      return this.currentList === 'notPass'
    },
    tips() {
      return this.isDeleteOper ? '您确定要删除吗？' : '您确定要撤稿吗？'
    },
    isDeleteOper() {
      return this.handleFlag === 'delete'
    }
  },
  created() {
    this.$store.commit('UPDATE_BreadMenuData', [])
  },
  methods: {
    // 获取分类列表
    async getNavList(parentId, currentId) {
      this.emptyText = ''
      let { status, data } = await APIS.postCatCategory()
      if (status === 0 && data && data.length !== 0) {
        this.navData = data.map(item => {
          return {
            id: item.id,
            name: item.name,
            level: item.level,
            code: item.code,
            children:
              (item.children.length !== 0 &&
                item.children.map(subItem => {
                  return {
                    id: subItem.id,
                    name: subItem.name,
                    level: subItem.level,
                    children: []
                  }
                })) ||
              []
          }
        })
        this.expandId = parentId ? [Number(parentId)] : [this.navData[0].id]
        this.topCurrentKey = parentId || this.navData[0].id
        this.secCurrentKey = currentId || ''
        this.currentId = currentId
          ? Number(currentId)
          : parentId
            ? Number(parentId)
            : this.navData[0].id
        this.$nextTick(() => {
          this.$refs.commonNav.$refs.tree.setCurrentKey(this.currentId)
        })
        this.getSpcialQuery()
      } else {
        this.navData = []
        this.emptyText = '暂无数据'
      }
    },
    // 获取列表
    async getSpcialQuery() {
      this.empty = ''
      let params = Object.assign({}, this.$refs[this.currentList].getParams(), {
        dataCategoryIds: this.currentId,
        isMy: 1,
        showContent: 0,
        timeFlag: undefined
      })
      this.categoryId = this.categoryObj[this.$refs[this.currentList].$refs.conditon.articleTypeId]
      if (!this.isNoPassList) {
        params = Object.assign({}, params, { status: '5' })
      }
      if (params.page === 1) {
        this.totalData = []
      }
      let conditonParams = {
        status: params.status === '5' ? '2,4,6' : params.status,
        articleTypeIds: params.articleTypeIds || '0',
        beginCreated: params.beginCreated,
        endCreated: params.endCreated,
        timeFlag: this.$refs[this.currentList].getParams().timeFlag,
        dataCategoryIds: this.currentId
      }
      this.$store.commit('editor/updateEditorSearchParams', conditonParams)
      let { status, data } = await jlxkAPIS.postSpcialQuery({ data: params })
      if (status === 0 && data && data.result && data.result.length !== 0) {
        this.total = data.total
        this.listData = data.result.map((item, index) => {
          return {
            id: item.id,
            topicIndex: (params.page - 1) * params.pagesize + index + 1,
            publisher: item.publisher,
            author: item.author,
            status: item.oristatus,
            coverpicurl:
              String(item.articleTypeId) === '3'
                ? ''
                : item.coverPicUrl
                  ? item.coverPicUrl.split(';')[0]
                  : item.attachments && item.attachments.length !== 0
                    ? item.attachments[0].s_uri
                    : '',
            attachments: item.attachments,
            originalpicurl: item.originalPicUrl,
            zzsrc: item.zzsrc,
            description: item.description,
            title: item.title,
            articletypeid: item.articleTypeId,
            pubdate: item.pubdate,
            topCategory: item.topCategory,
            involvePerson: item.involvePerson,
            province: item.province,
            city: item.city,
            county: item.county,
            village: item.village,
            location: item.location,
            region: item.province + item.city + item.county + item.village,
            department: item.department,
            totalEpisodeNumber: item.totalEpisodeNumber,
            episodeNumber: item.episodeNumber,
            created: item.created,
            topTopic: item.topTopic,
            topTopicId: item.topTopicId,
            secTopic: item.secTopic,
            secTopicId: item.secTopicId,
            theme: item.topTopic + item.secTopic,
            keyWords: item.keyWords,
            isAppraise: item.isAppraise,
            hasPic: item.hasPic,
            isSensitive: item.isSensitive === 1 ? '是' : '否',
            nation: item.nation,
            topDataCategoryId: item.topDataCategoryId,
            contentAttribute: item.contentAttribute,
            categoryName: `${item.topDataCategory} -> ${item.secDataCategory}`
          }
        })
        this.listData.forEach(item => {
          let isIndex = this.totalData.findIndex(
            i => String(i.id) === String(item.id)
          )
          if (isIndex !== -1) return false
          this.totalData.push(item)
        })
        this.active = 0
        this.$refs[this.currentList].$refs.list.active = 1
        this.$nextTick(() => {
          this.$refs[this.currentList].handleCheckedChange()
        })
        if (document.querySelector('.jlxk-view-container .jlxk-data-content .list')) {
          toTopAnimation('.jlxk-view-container .jlxk-data-content .list')
        }
        if (document.querySelector('.data-view-detail-container .detail-container')) {
          toTopAnimation('.data-view-detail-container .detail-container')
        }
      } else {
        this.empty = '当前未查询到任何数据'
        this.listData = []
        this.total = 0
      }
    },
    // 删除、撤稿
    async getSpcialDelete() {
      let ids = this.$refs[this.currentList].checkedLists.join(',')
      let params = {
        ids: this.isDetail ? this.currentItem.id : ids
      }
      if (!this.isDeleteOper) {
        params = Object.assign({}, params, {
          toStatus: 2,
          operate: '撤稿'
        })
      }
      let _apis = this.isDeleteOper
        ? jlxkAPIS.postSpcialDelete
        : jlxkAPIS.postSpcialCheck
      let { status, message } = await _apis({
        data: params
      })
      if (status === 0) {
        this.$refs[this.currentList].resetCheck()
        this.$refs.sureDialog.cyDialogCommon = false
        this.totalData = []
        this.getSpcialQuery()
      } else {
        this.global_.handleMessageTips(message, 'error')
      }
    },
    initParams() {
      this.active = 0
      this.currentTab = 'detail'
    },
    // 切换左侧菜单
    handleChangeNav(val) {
      if (val.id === this.currentId) return false
      this.topCurrentKey = val.parentId || val.id
      this.secCurrentKey = val.parentId ? val.id : ''
      this.currentId = val.id
      this.totalData = []
      this.expandFlag = true
      this.initParams()
      this.$refs[this.currentList].initParams()
      this.getSpcialQuery()
    },
    // 切换选中稿件
    changeSelected(index) {
      this.active = index
      if (
        document.querySelector('.data-view-detail-container .detail-container')
      ) {
        toTopAnimation('.data-view-detail-container .detail-container')
      }
    },
    // 操作：删除、撤稿
    handleCommand(value) {
      this.isDetail = value.isDetail
      this.handleFlag = value.flag
      this.$refs.sureDialog.cyDialogCommon = true
    },
    updateExpand(val) {
      this.expandFlag = val
    },
    // 切换tab
    handleChangeTab() {
      this.$nextTick(() => {
        this.getSpcialQuery()
      })
    }
  },
  watch: {
    $route: {
      handler(newVal) {
        this.initParams()
        if (JSON.stringify(newVal.query) === '{}') {
          this.getNavList()
          return false
        }
        this.$nextTick(() => {
          let params = this.$store.state['editor'].editorSearchParams
          if (JSON.stringify(params) !== '{}') {
            this.$refs[this.currentList].$refs.conditon.recordParmas(params)
          }
        })
        this.getNavList(newVal.query.parentId, newVal.query.currentId)
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
.jlxk-view-container {
  display: flex;
  /deep/ .el-tabs {
    .el-tabs__header {
      margin: 0;
      border-radius: 5px 5px 0 0;
      .el-tabs__nav-wrap {
        overflow: auto;
        .el-tabs__nav-scroll {
          height: 49px;
        }
        &::after {
          height: 1px;
        }
      }
      .el-tabs__active-bar {
        bottom: -4px;
      }
      .el-tabs__item {
        height: 45px;
        line-height: 45px;
        font-size: 15px;
        color: #454647;
        padding: 0 30px;
        box-shadow: none;
        &.is-active {
          color: #4497ec;
        }
      }
    }
  }
  /deep/ .el-tabs.tag-tab-conditon {
    width: 440px;
    @extend .comBackground;
    .el-tabs__header {
      width: 100%;
      background: #ffffff;
    }
    .el-tabs__content {
      overflow: initial;
      background-color: #fff;
      min-height: calc(100vh - 150px);
      .data-view-detail-container {
        .detail-container {
          padding: 15px 20px;
          height: calc(100vh - 195px);
          overflow-y: auto;
        }
      }
    }
    &.tag-no-operate-conditon {
      .el-tabs__content {
        .data-view-detail-container {
          .detail-container {
            height: calc(100vh - 147px);
          }
        }
      }
    }
  }
  .list-container {
    display: flex;
    flex-direction: column;
    margin: 0 12px 0 152px;
    @extend .comBackground;
    /deep/ .el-tabs {
      .el-tabs__header {
        margin: 0 15px 0 25px;
        .el-tabs__item {
          line-height: 48px;
          padding: 0 60px 0 0;
        }
      }
    }
    /deep/ .jlxk-data-content {
      position: relative;
      margin: 0;
      box-shadow: none;
      &.jlxk-data-content-expand {
        height: calc(100vh - 145px);
      }
      i.condition-expand-icon.icon-arrow-up {
        position: absolute;
        right: 25px;
        top: -30px;
      }
    }
  }
  .cy-common-left-nav {
    /deep/ .el-tree-node {
      &.is-current {
        > .el-tree-node__content {
          background-color: rgba(255, 255, 255, 0.85);
          .el-tree-node__expand-icon {
            background-image: url("~@assets/imgs/jlxk/editor-bg-active.png");
          }
          > div {
            > .el-tree-node__label {
              color: #555;
            }
          }
        }
      }
      &.is-expanded {
        .el-tree-node__children {
          .el-tree-node.is-current {
            > .el-tree-node__content {
              background: transparent;
              .el-tree-node__expand-icon {
                background: transparent;
              }
            }
          }
        }
      }
    }
  }
  /deep/ .sureDialog {
    .delete-icon-box {
      width: 60px;
      height: 60px;
      background-color: #f3c245;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto 25px;
    }
    .delete-text {
      text-align: center;
    }
    .el-dialog__footer {
      margin: 0;
    }
  }
}
</style>
